var current_point = 0;

let locale = window.Shopify.locale;

$(document).ready(function () {
    $(".my-coupon").click(function () {
        openMyCoupon($(this));
    });

    function openMyCoupon(page) {

        if (locale != 'th') {
            window.location.href =
                "/" + locale + "/pages/membership-my-coupon";
        } else {
            window.location.href = "/pages/membership-my-coupon";
        }
    }
});

function openRewardDetail(id) {

    if (locale != 'th') {
        window.location.href =
            "/" + locale + "/pages/membership-reward-detail" + "?id=" + encodeURIComponent(id);
    } else {
        window.location.href = "/pages/membership-reward-detail" + "?id=" + encodeURIComponent(id);
    }
}

function filterReward(cus_phone, category = false, label = false) {
    filter_cate_items = document.getElementsByClassName("filter-item-cate");
    if (category != false) {
        for (var i = 0; i < filter_cate_items.length; i++) {
            if (filter_cate_items[i].textContent.includes(category)) {
                filter_cate_items[i].classList.add("filter_cate_click");
            } else {
                filter_cate_items[i].classList.remove("filter_cate_click");
            }
        }
    }
    filter_label_items = document.getElementsByClassName("filter-item-label");
    if (label != false) {
        for (var i = 0; i < filter_label_items.length; i++) {
            if (filter_label_items[i].textContent.includes(label)) {
                filter_label_items[i].classList.add("filter_label_click");
            } else {
                filter_label_items[i].classList.remove("filter_label_click");
            }
        }
    }
    document.getElementById("redeem-reward-list").innerHTML = "";
    try {
        var cate =
            document.getElementsByClassName("filter_cate_click")[0].children[0]
                .textContent;
        if (cate == "Flagship Store") {
            cate = "Flagship";
        }
    } catch {
        var cate = false;
    }
    try {
        var labe =
            document.getElementsByClassName("filter_label_click")[0].children[0]
                .textContent;
    } catch {
        var labe = false;
    }
    rewardOnLoad(parseInt(cus_phone), (category = cate), (label = labe));
}

function filterClear(cus_phone, category = false, label = false) {
    filter_cate_items = document.getElementsByClassName("filter-item-cate");
    if (category != false) {
        for (var i = 0; i < filter_cate_items.length; i++) {
            filter_cate_items[i].classList.remove("filter_cate_click");
        }
    }
    filter_label_items = document.getElementsByClassName("filter-item-label");
    if (label != false) {
        for (var i = 0; i < filter_label_items.length; i++) {
            filter_label_items[i].classList.remove("filter_label_click");
        }
    }
    document.getElementById("redeem-reward-list").innerHTML = "";
    try {
        var cate =
            document.getElementsByClassName("filter_cate_click")[0].children[0]
                .textContent;
    } catch {
        var cate = false;
    }
    try {
        var labe =
            document.getElementsByClassName("filter_label_click")[0].children[0]
                .textContent;
    } catch {
        var labe = false;
    }
    rewardOnLoad(parseInt(cus_phone), (category = cate), (label = labe));
}

function rewardOnLoad(cus_phone, category = false, label = false) {
    static_data = {
        'no_enough_points': 'Insufficient points balance',
        'points': 'Points',
        'expire_in': 'Expires in: ',
        'no_reward': 'No reward available'
    }
    if (locale == 'th') {
        static_data = {
            'no_enough_points': 'คะแนนคงเหลือไม่เพียงพอ',
            'points': 'คะแนน',
            'expire_in': 'หมดอายุใน: ',
            'no_reward': 'ไม่มีรางวัล'
        }
    }
    var settings = {
        url: "https://dev.api.backend.gw.int.suparagroup.com/gq-connect/auth/token",
        method: "POST",
        timeout: 0,
        headers: {
            "Content-Type": "application/json",
        },
        data: JSON.stringify({
            api_key: "4940F195-2EAD-42A1-84FE-55A6B4416FE6",
            client: "magenest",
        }),
    };

    $.ajax(settings).done(function (response) {
        supara_token = response.data.token;
        var ajax_customer = {
            url:
                "https://dev.api.backend.gw.int.suparagroup.com/gq-connect/magenest/customers/get?mobile=" +
                parseInt(cus_phone) +
                "&source=INSTORE",
            method: "GET",
            timeout: 0,
            headers: {
                Authorization: "Bearer " + response.data.token,
            },
        };

        $.ajax(ajax_customer).done(function (cus) {
            document.getElementById("currentTier").innerText =
                cus.data.customers[0].current_slab;
            document.getElementById("avatar_loyalty_point2").innerText =
                cus.data.customers[0].points_summaries[0].total_available_points;
            current_point = cus.data.customers[0].points_summaries[0].total_available_points;
            var url = "https://dev.api.backend.gw.int.suparagroup.com/gq-connect/customers/rewards?mobile=" + parseInt(cus_phone);
            if (label == "Popular" || label == "เป็นที่นิยม") {
                url = url + "&filter_by=popular";
            } else if (label == "Descending" || label == "มากไปน้อย") {
                url = url + "&sort_order=desc";
            } else if (label == "Ascending" || label == "น้อยไปมาก") {
                url = url + "&sort_order=asc";
            }
            var ajax_reward = {
                url: url,
                method: "GET",
                timeout: 0,
                headers: {
                    Authorization: "Bearer " + response.data.token,
                },
            };
            $.ajax(ajax_reward).done(function (response) {
                var reward_list_html = "";
                if ('rewards' in response.data && response.data.rewards.length > 0) {
                    rewards = response.data.rewards;
                    for (i = 0; i < rewards.length; i++) {
                        reward = rewards[i].reward;
                        var valid_category = false;
                        var categoryList = "";
                        for (j = 0; j < reward.categoryList.length; j++) {
                            if (category != false) {
                                if (
                                    reward.categoryList[j].name.toLowerCase() ==
                                    category.toLowerCase()
                                ) {
                                    valid_category = true;
                                }
                            }
                            categoryList =
                                categoryList +
                                "<div class='filter-item'>" +
                                reward.categoryList[j].name +
                                "</div>";
                        }
                        if (category == false || valid_category == true) {
                            var invalid_overlay = "";
                            var invalid_text = "";
                            var clickable = 'onclick="openRewardDetail(' + reward.id + ')"';
                            var invalid = false;

                            if (parseInt(current_point) < parseInt(reward.intouchPoints)) {
                                invalid_overlay = '<div class="redeem-overlay"></div>';
                                invalid_text =
                                    '<div class="reward-locked-div"><svg class="lock-icon" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" stroke="#000000"><path d="M2 16C2 13.1716 2 11.7574 2.87868 10.8787C3.75736 10 5.17157 10 8 10H16C18.8284 10 20.2426 10 21.1213 10.8787C22 11.7574 22 13.1716 22 16C22 18.8284 22 20.2426 21.1213 21.1213C20.2426 22 18.8284 22 16 22H8C5.17157 22 3.75736 22 2.87868 21.1213C2 20.2426 2 18.8284 2 16Z" stroke="#000000" stroke-width="1.5"></path> <circle cx="12" cy="16" r="2" stroke="#000000" stroke-width="1.5"></circle> <path d="M6 10V8C6 4.68629 8.68629 2 12 2C15.3137 2 18 4.68629 18 8V10" stroke="#000000" stroke-width="1.5" stroke-linecap="round"></path></svg>'+static_data.no_enough_points+'</div>';
                            } else {
                                invalid = true;
                            }
                            if (!['Ready to use', 'พร้อมใช้งาน'].includes(label) || (['Ready to use', 'พร้อมใช้งาน'].includes(label) && invalid == true)) {
                                reward_list_html =
                                    reward_list_html +
                                    '<div class="redeem-reward-div"><a ' +
                                    clickable +
                                    ">" +
                                    '<div class="redeem-reward-img-div">' +
                                    invalid_overlay +
                                    '<img class="redeem-reward-img" src="' +
                                    reward.imageUrl +
                                    '"><div class="reward-tag">' +
                                    reward.label +
                                    "</div>" +
                                    invalid_text +
                                    '</div><div class="redeem-reward-label-div"><div class="redeem-reward-title">' +
                                    reward.name +
                                    '</div><div class="redeem-reward-point-div"><img src="https://cdn.shopify.com/s/files/1/0631/7755/6173/files/GQ-Coin.png?v=1715157282" class="gqcoin_icon"><span class="redeem-reward-point"> ' +
                                    reward.intouchPoints +
                                    ' </span>'+static_data.points+'</div><div class="highest-tier">' +
                                    reward.tier +
                                    '</div><div class="filter-line">' +
                                    categoryList +
                                    '</div><div class="reward-expire">'+static_data.expire_in +
                                    reward.endTime +
                                    "</div></div></a></div>";
                            }
                        }
                    }
                }
                if (reward_list_html == "") {
                    reward_list_html = static_data.no_reward;
                }
                document.getElementById("redeem-reward-list").innerHTML =
                    reward_list_html;
            });
        });
    });
}
